import { createContext, useContext, useState, useEffect } from 'react';
import { getCookieConsentValue } from 'react-cookie-consent';

export type TCookieAcceptance = {
  hasAcceptedCookies: boolean;
  updateCookieAcceptance: () => void;
};

export const CookieAcceptanceContext = createContext<TCookieAcceptance>({
  hasAcceptedCookies: false,
  updateCookieAcceptance: () => {},
});

// Move the cookie check logic here instead of importing from CookieConsent
const checkCookieConsent = (hide = false) => {
  if (typeof window === 'undefined') return false;

  const cookie = getCookieConsentValue('allow_treedis_cookie');
  if (cookie === undefined) {
    return hide ? true : false;
  }
  return cookie === 'true';
};

export const CookieAcceptanceProvider = ({ children }: { children: React.ReactNode }) => {
  const [hasAcceptedCookies, setHasAcceptedCookies] = useState(false);

  useEffect(() => {
    setHasAcceptedCookies(checkCookieConsent());
  }, []);

  const updateCookieAcceptance = () => {
    setHasAcceptedCookies(checkCookieConsent());
  };

  // During SSR, always return false for hasAcceptedCookies
  const contextValue = {
    hasAcceptedCookies: typeof window === 'undefined' ? false : hasAcceptedCookies,
    updateCookieAcceptance,
  };

  return (
    <CookieAcceptanceContext.Provider value={contextValue}>
      {children}
    </CookieAcceptanceContext.Provider>
  );
};

export const useCookieAcceptance = () => useContext(CookieAcceptanceContext);
